<template>
  <div class="space-y-2">
    <p class="h3-title">【E】生产执行数字化</p>
    <p class="text-bold pt-3">E1 计划排程</p>
    <p>{{info.p_f_1}}</p>
    <p>{{info.p_f_2}}</p>
    <p class="text-bold pt-3">E2*生产管控</p>
    <p>{{info.p_f_3}}</p>
    <p>{{info.p_f_4}}</p>
    <p class="text-bold pt-3">E3*质量管理</p>
    <p>{{info.p_f_5}}</p>
    <p>{{info.p_f_6}}</p>
    <p class="text-bold pt-3">E4*设备管理</p>
    <p>{{info.p_f_7}}</p>
    <p>{{info.p_f_8}}</p>
    <p class="text-bold pt-3">E5*安全生产</p>
    <p>{{info.p_f_9}}</p>
    <p>{{info.p_f_10}}</p>
    <p class="text-bold pt-3">E6*能耗管理</p>
    <p>{{info.p_f_11}}</p>
    <p>{{info.p_f_12}}</p>
  </div>
</template>

<script>

// 生产执行数字化1
export default {
  props: ['info']
}
</script>
